import React, { useEffect, useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom';
import { lookupMed } from 'helpers/medicationHelpers.js';
import { ingredientsCreateState, resetIngredientsCreateState } from 'store/storeValtio';
import { getCurrentUserId } from 'store/storeValtio';
import IngredientDose from './IngredientDose';
import IngredientName from './IngredientName';
import chevLeft from 'icons/chevron-left-24.png';

export default function AddIngredient(props) {
  const [step, setStep] = useState(1);
  const params = useParams();
  const medId = params.id;
  const med = lookupMed(medId);
  const currentUserId = getCurrentUserId();

  console.log('AddIngredient', medId);
  const navigate = useNavigate();

  useEffect(() => {
    resetIngredientsCreateState(null);
    ingredientsCreateState.user = currentUserId;
    ingredientsCreateState.medicationId = [];
    ingredientsCreateState.user = currentUserId;
  },[])

  function prev() {
    navigate(-1);
  }

  // called from child page
  function next(n) {
    console.log('AddIngredient next', n);
    if (n === 0) {
      navigate('/');
    }
    setStep(n);
  }

  return (
    <div className='mcard'>
      <div className='mcard-header'>
          <div className='hover:cursor-pointer' onClick={()=>prev()}>
              <img src={chevLeft} alt='' />
            </div>
          <div className='font-bold text-xl'>
            Ingredients for {med.name}
          </div>
      </div>
      <div>
        {step === 1 && <IngredientName med={med} next={next} />}
        {step === 2 && <IngredientDose med={med} next={next} />}
      </div>
    </div>
)
}

